import { defineComponent } from "vue";
export default defineComponent({
  name: "BaseToggle",
  inheritAttrs: false,
  props: {
    withRightLabel: {
      type: Boolean,
      "default": true
    },
    label: {
      type: String,
      "default": ""
    },
    modelValue: {
      type: Boolean,
      "default": false
    }
  },
  emits: ["update:modelValue"],
  methods: {
    handleToggle: function handleToggle(_ref) {
      var target = _ref.target;
      this.$emit("update:modelValue", target.checked);
    }
  }
});